var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "pm-summary-edit-page" },
    [
      _c(
        "div",
        { staticClass: "page-header" },
        [
          _c(
            "v-btn",
            { attrs: { icon: "", small: "" }, on: { click: _setup.goBack } },
            [_c("v-icon", [_vm._v("mdi-arrow-left")])],
            1
          ),
          _c("span", { staticClass: "page-title" }, [_vm._v("Edit PM Summary")])
        ],
        1
      ),
      _c(_setup.PmSummaryForm, {
        attrs: { wide: "", "edit-id": _setup.editId },
        on: { "on-success": _setup.goBack, "on-cancel": _setup.goBack }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }